export interface InfractionPromptInput {
  erScore?: number;
  infractionCount?: number;
}

export function buildInfractionPrompt({
  erScore,
  infractionCount,
}: InfractionPromptInput = {}): string {
  const scoreText = Number.isFinite(erScore)
    ? `Current ER score is ${Number(erScore).toFixed(2)}.`
    : "Current ER score unavailable.";
  const countText = Number.isFinite(infractionCount)
    ? `Detected infractions in recent window: ${Math.max(0, Number(infractionCount))}.`
    : "Detected infractions in recent window are unavailable.";

  return `${scoreText} ${countText} Provide a short de-escalation intervention for the trader with one immediate action and one reminder.`;
}
